import script from "./gstr3b.vue?vue&type=script&setup=true&lang=js"
export * from "./gstr3b.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__